import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, deleteDoc, query, where, getDocs, orderBy, updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { Randomcode } from '../components/rendom_code';
import { Helmet } from "react-helmet";
import Lodinging from "../components/loading";
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';
//page links      
//help
import Loading from '../components/loading';
import { VscRemove } from 'react-icons/vsc';
import { Saveusersdetails } from './save_users_details';
import { VscCheck } from "react-icons/vsc";
import { IoIosHelpCircle, IoIosHelpCircleOutline } from "react-icons/io";
import './account-details.css';
import { VscArrowLeft } from "react-icons/vsc";
import AccountDetailsKeyskills from './account-details-Key-skills';
export default function AccountDetails() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [usersdetails, setUsersdetails] = useState([]);
  const details = location.state?.details || {};
  const { showToast } = useToast();
  const formattedTitle = details
    .replace(/_/g, ' ')
    .charAt(0).toUpperCase() + details.replace(/_/g, ' ').slice(1);
  const navigate = useNavigate();
  
  const handleGoBack = () => {
  if (window.history.length > 1) {
    navigate(-1); // Go back
  } else {
    navigate('/'); // No history, go to home
  }
};
  useEffect(() => {
    fetchdetails();
  }, []);

  const fetchdetails = async () => {
    setIsLoading(true);
    try {
      const userQuery = query(
        collection(db, "users_details"),
        where("details", "==", details),
        where("guid", "==", Cookies.get("guid"))
      );
      const userSnapshot = await getDocs(userQuery);
      const usersData = userSnapshot.docs.map((userDoc) => ({
        uid: userDoc.id,
        ...userDoc.data()
      }));

      setUsersdetails(usersData);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleeducationSave = async () => {
    const educationLevel = document.getElementById('educationLevel').value;
    const institutioninput = document.getElementById('institutioninput').value;
    const marksinput = document.getElementById('marksinput').value;
    const yearinput = document.getElementById('yearinput').value;
    const descriptionInput = document.getElementById('descriptioninput').value;

    if (!educationLevel || !institutioninput || !descriptionInput ) {
      showToast("Please fill in all fields.");
      return;
    }
    const uid = Randomcode(9);
    showToast('Publishing...');
    setIsLoading(true);
    const result = await Saveusersdetails({
      uid,
      details,
      title: educationLevel,
      value: institutioninput,
      marks:marksinput,
      year: yearinput,
      description: descriptionInput,
    });
    if (result.success) {
      showToast('Successfully saved');
      setTimeout(() => {
        document.getElementById('educationLevel').value = "";
        document.getElementById('institutioninput').value = "";
        document.getElementById('marksinput').value = "";
        document.getElementById('yearinput').value = "";
        document.getElementById('descriptioninput').value = "";
        fetchdetails();
      }, 1000);
    } else {
      showToast("Failed to publish post: " + (result.error || "Unknown error"));
      console.error("Save Error:", result.error);
    }
  };
  const handle_projects_Save = async () => {
    const projects_name = document.getElementById('projects_name_input').value; 
    const projects_description = document.getElementById('projects_description_input').value;

    if (!projects_name || !projects_description) {
      showToast("Please fill in all fields.");
      return;
    }
    const uid = Randomcode(9);
    showToast('Publishing...');
    setIsLoading(true);
    const result = await Saveusersdetails({
      uid,
      details,
      title: projects_name,
      value: projects_description, 
    });
    if (result.success) {
      showToast('Successfully saved');
      setTimeout(() => {
        document.getElementById('projects_name_input').value = "";
        document.getElementById('projects_description_input').value = ""; 
        fetchdetails();
      }, 1000);
    } else {
      showToast("Failed to publish post: " + (result.error || "Unknown error"));
      console.error("Save Error:", result.error);
    }
  };
 
  const RemoveSkillscategories = async (skilsdetails) => {
    try {
      const jcq = query(
        collection(db, "users_details"),
        where("uid", "==", skilsdetails)
      );

      const snapshot = await getDocs(jcq);

      if (!snapshot.empty) {
        snapshot.forEach(async (docItem) => {
          await deleteDoc(doc(db, "users_details", docItem.id));
        });
        console.log("details removed successfully.");
        showToast('Removed successfully.');
        setTimeout(() => {
          fetchdetails();
        }, 1000);
      } else {
        console.log("No matching details found to remove.");
      }
    } catch (error) {
      console.error("Error removing details:", error);
    }
  };
  return (
    <div>
      <div className="status-bar">
        <div className="container_size">
          <div className="status-bar_size">
            <div className='left_body'>
              <VscArrowLeft onClick={handleGoBack} className='back_arrow_btn' />
            </div>
            <div className='name-bar-body'>{formattedTitle}</div>
            <div className='right_body'>
              <div
                onClick={() => navigate('/help')}
                className={`help-button-icon ${location.pathname === '/help' ? 'active' : ''}`}
                title="Help Center"
              >
                {location.pathname === '/help' ? <IoIosHelpCircle className="icon" /> : <IoIosHelpCircleOutline className="icon" />}

                <span className="button-text">Help</span>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className='app_header_height'></div>
      <div className="container_roots">
        <div className="container_size">
          <div className='account-details-body'>
            <div className='post-container'>
              <div className='post_div'>
                <div className='contact-title-div'>
                  <div className='contact-title'>Account Details {formattedTitle}</div>
                  <div className='contact-details'>Fill in the details to Showcase Your Talent & Get Hired</div>
                </div>
                {details === "education" ? (
                  <div>
                    <table className='data-input-body'>
                      <tr><td className='contact-details'>
                        Education Level
                      </td></tr>
                      <tr><td >
                        <select name="educationLevel" id='educationLevel'>
                          <option value="">Select Level</option>
                          <option value="highschool">High School</option>
                          <option value="diploma">Diploma</option>
                          <option value="bachelor">Bachelor's Degree</option>
                          <option value="master">Master's Degree</option>
                          <option value="doctorate">Doctorate / PhD</option>
                          <option value="certification">Professional Certification</option>
                        </select>
                      </td></tr>
                      <tr><td className='contact-details'>
                        Institution
                      </td></tr>
                      <tr><td >
                        <div>
                          <input
                            maxLength={60} style={{ margin: '5px' }} id='institutioninput' placeholder='Enter Name'></input>

                          <input
                            maxLength={10} style={{ margin: '5px' }} id='marksinput' placeholder='Enter Marks %'></input>
                          <input
                            maxLength={10} style={{ margin: '5px' }} id='yearinput' placeholder='Enter Year'></input>
                        </div>
                      </td></tr>
                      <tr><td className='contact-details'>
                        Description
                      </td></tr>
                      <tr><td >
                        <textarea className='data-input' id='descriptioninput'
                          rows={6}
                          maxLength={1000} placeholder='Enter Details'></textarea>
                      </td></tr>
                    </table>
                    <div>
                      <div className='button-ui' onClick={handleeducationSave}><VscCheck className='icon' /> Save</div>
                    </div> 
                    <br />
                    <div>
                      {isLoading ? (
                        <></>
                        // <Loading />
                      ) : (
                        <table className='skillscategories-table'>
                          <tbody>
                            {usersdetails.map((cat, index) => {
                              const checkboxId = `chk-${index}`;
                              return (
                                <tr key={index}>
                                  <td>
                                    <div className="skillscategory-item">
                                      <div className="title-row">
                                        <table width={`100%`}>
                                          <tr>
                                            <th>
                                              Education
                                            </th>
                                            <th>
                                              Institution
                                            </th>
                                            
                                          </tr>
                                          <tr>
                                            <td>
                                              {cat.title}</td>
                                            <td>
                                              {cat.value}</td>
                                              </tr>
                                              <tr>
                                            <td>Marks: {cat.marks}%</td>
                                            <td>Year: {cat.year}</td>
                                          </tr>
                                        </table>


                                        {/* Checkbox */}
                                        <table>
                                          <tr>
                                            <td>
                                              <input type="checkbox" id={checkboxId} style={{ marginRight: '6px' }} />

                                            </td>
                                            <td> <label for='checkboxId'  >Agree</label></td>
                                          </tr>
                                        </table>

                                        {/* Label for the checkbox that acts like a button */}
                                        <label
                                          htmlFor={checkboxId}
                                          className="button-ui4"
                                          style={{ cursor: "pointer", color: "#d00" }}
                                          onClick={() => {
                                            const isChecked = document.getElementById(checkboxId).checked;
                                            if (isChecked) {
                                              RemoveSkillscategories(cat.uid);
                                            } else {
                                              showToast("Please check the box to agree before removing.");
                                            }
                                          }}
                                        >
                                          <VscRemove className="icon" /> Remove
                                        </label>
                                      </div>

                                      <div className="description-text">{cat.description}</div>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>
                ) :
                  details === "key_skills" ? (
                    <AccountDetailsKeyskills />
                  ) : details === "resume" ? (
                    <div>
                      <table className='data-input-body'>
                        <tr><td className='lable-text'>
                        Title
                        </td></tr>
                        <tr><td >
                          <input className='data-input' id='projects_name_input'
                            maxLength={60} placeholder='Enter name'></input>
                        </td></tr>
                        <tr><td className='lable-text'>
                        Resume Details
                        </td></tr>
                        <tr><td >
                          <textarea className='data-input' id='projects_description_input'
                            rows={50}
                            maxLength={10000} placeholder='Enter Details'></textarea>
                        </td></tr>
                      </table>
                      <div>
                        <br />
                        <div className='button-ui' onClick={handle_projects_Save}><VscCheck className='icon' /> Save</div>
                      </div>
                    </div>
                  )  : details === "projects" ? (
                    <div>
                      <table className='data-input-body'>
                        <tr><td className='lable-text'>
                        Projects
                        </td></tr>
                        <tr><td >
                          <input className='data-input' id='projects_name_input'
                            maxLength={60} placeholder='Enter title'></input>
                        </td></tr>
                        <tr><td className='lable-text'>
                        Details
                        </td></tr>
                        <tr><td >
                          <textarea className='data-input' id='projects_description_input'
                            rows={6}
                            maxLength={5000} placeholder='Enter Details'></textarea>
                        </td></tr>
                      </table>
                      <div>
                        <br />
                        <div className='button-ui' onClick={handle_projects_Save}><VscCheck className='icon' /> Save</div>
                      </div>

                      <div>
                      {isLoading ? (
                        <></>
                        // <Loading />
                      ) : (
                        <table className='skillscategories-table'>
                          <tbody>
                            {usersdetails.map((cat, index) => {
                              const checkboxId = `chk-${index}`;
                              return (
                                <tr key={index}>
                                  <td>
                                    <div className="skillscategory-item">
                                      <div className="title-row">
                                        <table width={`100%`}>
                                          <tr>
                                            <th>
                                            Projects
                                            </th>
                                            <th>
                                            Details
                                            </th> 
                                          </tr>
                                          <tr>
                                            <td>
                                              {cat.title}</td>
                                            <td>
                                              {cat.value}</td> 
                                          </tr>
                                        </table>


                                        {/* Checkbox */}
                                        <table>
                                          <tr>
                                            <td>
                                              <input type="checkbox" id={checkboxId} style={{ marginRight: '6px' }} />

                                            </td>
                                            <td> <label for='checkboxId'  >Agree</label></td>
                                          </tr>
                                        </table>

                                        {/* Label for the checkbox that acts like a button */}
                                        <label
                                          htmlFor={checkboxId}
                                          className="button-ui4"
                                          style={{ cursor: "pointer", color: "#d00" }}
                                          onClick={() => {
                                            const isChecked = document.getElementById(checkboxId).checked;
                                            if (isChecked) {
                                              RemoveSkillscategories(cat.uid);
                                            } else {
                                              showToast("Please check the box to agree before removing.");
                                            }
                                          }}
                                        >
                                          <VscRemove className="icon" /> Remove
                                        </label>
                                      </div>

                                      <div className="description-text">{cat.description}</div>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      )}
                    </div>


                    </div>
                  ) 
                  : details === "profile_summary" ? (
                    <div>
                      <table className='data-input-body'>
                        <tr><td className='lable-text'>
                        Title
                        </td></tr>
                        <tr><td >
                          <input className='data-input' id='projects_name_input'
                            maxLength={60} placeholder='Enter title'></input>
                        </td></tr>
                        <tr><td className='lable-text'>
                        Details
                        </td></tr>
                        <tr><td >
                          <textarea className='data-input' id='projects_description_input'
                            rows={6}
                            maxLength={5000} placeholder='Enter Details'></textarea>
                        </td></tr>
                      </table>
                      <div>
                        <br />
                        <div className='button-ui' onClick={handle_projects_Save}><VscCheck className='icon' /> Save</div>
                      </div>

                      <div>
                      {isLoading ? (
                        <></>
                        // <Loading />
                      ) : (
                        <table className='skillscategories-table'>
                          <tbody>
                            {usersdetails.map((cat, index) => {
                              const checkboxId = `chk-${index}`;
                              return (
                                <tr key={index}>
                                  <td>
                                    <div className="skillscategory-item">
                                      <div className="title-row">
                                        <table width={`100%`}>
                                          <tr>
                                            <th>
                                            Title
                                            </th>
                                            <th>
                                            Details
                                            </th> 
                                          </tr>
                                          <tr>
                                            <td>
                                              {cat.title}</td>
                                            <td>
                                              {cat.value}</td> 
                                          </tr>
                                        </table>


                                        {/* Checkbox */}
                                        <table>
                                          <tr>
                                            <td>
                                              <input type="checkbox" id={checkboxId} style={{ marginRight: '6px' }} />

                                            </td>
                                            <td> <label for='checkboxId'  >Agree</label></td>
                                          </tr>
                                        </table>

                                        {/* Label for the checkbox that acts like a button */}
                                        <label
                                          htmlFor={checkboxId}
                                          className="button-ui4"
                                          style={{ cursor: "pointer", color: "#d00" }}
                                          onClick={() => {
                                            const isChecked = document.getElementById(checkboxId).checked;
                                            if (isChecked) {
                                              RemoveSkillscategories(cat.uid);
                                            } else {
                                              showToast("Please check the box to agree before removing.");
                                            }
                                          }}
                                        >
                                          <VscRemove className="icon" /> Remove
                                        </label>
                                      </div>

                                      <div className="description-text">{cat.description}</div>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      )}
                    </div> 
                    </div>
                  ) : null}



              </div>
              <div className='post_updates'>
                <div className='post_div' >
                  <div class="message">

                    <p class="formal-info">
                      <span>✅</span> Please provide your Wire account details to complete your profile, highlight your skills, and increase your chances of getting hired.
                    </p>
                    <p class="formal-info">
                      <span>✨</span>
                      By adding your account details, you'll enable potential employers to quickly assess your expertise and consider you for relevant opportunities. This step is essential in showcasing your professionalism and standing out in a competitive job market.
                    </p>


                    <p class="formal-info">
                      <span>✨</span> Let the world see what you’ve got! Add your Wire account details to stand out and attract job opportunities.
                    </p>
                    <p class="formal-info">
                      Sharing your Wire account makes it easier for recruiters to reach out to you directly. It’s a simple step that could open doors to exciting career prospects, and give you the visibility you deserve.
                    </p>


                    <p class="formal-info">
                      <span>💼</span> Complete your Wire account information to showcase your talent, build trust with clients, and get hired faster.
                    </p>
                    <p class="formal-info">
                      <span>✨</span>
                      This is your chance to professionally present your skills and achievements. A complete profile lets clients and employers view your qualifications and directly connect with you, leading to quicker job offers and collaborations.
                    </p>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
